import HomeHero from '../components/HomeHero';
import WhyUs from '../components/WhyUs';
import AudienceSplit from '../components/AudienceSplit';
import GoogleReviewsWidget from '../components/GoogleReviewsWidget';
import FounderSection from '../components/FounderSection';
import CoverageContactSection from '../components/CoverageContactSection';
import Faq from '../components/Faq';
import { useSeoMeta } from '../hooks/useSeoMeta';
import { useScrollToHash } from '../hooks/useScrollToHash';
import { buildFaqSchema } from '../utils/structuredData';
import { HOME_FAQ_SHORT } from '../data/homeFaq';

const HOME_JSON_LD = [buildFaqSchema(HOME_FAQ_SHORT)];

const REVIEWS_TITLE = (
  <>
    Ils m’ont fait <span className="text-accent-soft">confiance</span>
  </>
);

const HomePage = () => {
  useScrollToHash();
  useSeoMeta({
    title: 'Réparation téléphone & PC à domicile – Viry/Genève | SOS IT',
    description:
      'Réparation de téléphone et dépannage informatique à domicile, création de site web à Viry, près de Genève. Prix annoncé avant toute intervention.',
    path: '/',
    jsonLd: HOME_JSON_LD,
  });

  return (
    <>
      <HomeHero />
      <GoogleReviewsWidget
        title={REVIEWS_TITLE}
        collapseOnMobile
        intro="Particuliers et professionnels de la région partagent leur expérience sur Google."
      />
      <WhyUs />
      <AudienceSplit />
      <FounderSection />
      <CoverageContactSection />
      <Faq />
    </>
  );
};

export default HomePage;
